import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

interface SnackbarAlertProps {
  open: boolean;
  handleClose: () => void;
  state: { data: string };
  severity: "error" | "warning" | "info" | "success"; // Define severity types
  variant: "filled" | "outlined" | "standard"; // Define variant types
}

const SnackbarAlert: React.FC<SnackbarAlertProps> = ({
  open,
  handleClose,
  state,
  severity,
  variant,
}) => {
  const onClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    handleClose();
  };

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      autoHideDuration={4000}
      onClose={onClose}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant={variant}
        sx={{ width: "100%" }}
      >
        {state.data}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarAlert;
